import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../constants'
import { fontSize3XSmall, grayLight20, black } from '../../constants/principles'
import ProgressDot from './progressDot'
import { BrowserUtils } from '../../utils/siteUtils'

export default function progressStep({ first, last, index, currentStep, furthestStep, step, onClick }) {
  const showStep = BrowserUtils.isDesktop()
  return (
    <StyledDiv data-testid={`progressStep-${step?.toString().replace(/[^A-Z0-9]/ig, "-").toLowerCase()}`} first={first} last={last} onClick={onClick}>
      <StyledDotDiv>{<ProgressDot index={index} currentStep={currentStep} furthestStep={furthestStep} first={first} last={last} />}</StyledDotDiv>
      <StyledTextDiv incomplete={index >= currentStep}>{showStep && step}</StyledTextDiv>
    </StyledDiv>
  )
}

const StyledDotDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
`

const StyledTextDiv = styled.div`
  font-size: ${fontSize3XSmall};
  display: none;
  color: ${p => (p.incomplete ? grayLight20 : black)};
  @media (min-width: ${breakpoints.mid}px) {
    display: block;
  }
  text-align: center;
`
const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  flex-grow: ${p => (p.first || p.last ? 1 : 2)};
  align-items: ${p => (p.first ? 'flex-start' : p.last ? 'flex-end' : 'center')};
`
